import React from 'react'
import { Grid, LinearProgress, Typography, makeStyles } from '@material-ui/core'
import { Redirect, useHistory } from 'react-router-dom'
import FilterButton from './components/FilterButton'
import DateFilterButton from './components/DateFilterButton'
import useReports from '../../hooks/modules/reports/useReports'

import ActivationsCard from './components/ActivationsCards';
import TransactionsCard from './components/TransactionsCards';
import CardholdersCard from './components/CardholdersCard';
import StackBarTransactions from './components/StackBarTransactions';
import DetailTransactionPieChart from './components/DetailTransactionPieChart';
import TransactionListCard from './components/TransactionListCard.jsx/TransactionListCard'
import Unauthorized from '../../components/Unauthorized'

const Reports = () => {
    const { replace } = useHistory()
    const classes = useStyles()
    const {view_data, actions, system,  catalogs={catalogs}, reportPermission } = useReports()

    const {groups, locations, group_id, location_id, start_date, end_date, transactions, pagination, total_data,
        activation_data, ocl_data, balance_data, transactions_stackbar, cardholders_data, masterTransaction} = view_data
    const {loading} = system

    return (
         <>
            {
                reportPermission.read === true ?

                <div>
                    <Grid container spacing={2}>
                        <Grid item xs>
                            <Typography variant='h6' color='primary' style={{fontWeight:600}}>Reports</Typography>
                        </Grid>
                        <Grid item>
                            <FilterButton label='Group' options={groups}  selected={group_id} onChange={actions.onChangeGroup}/>
                        </Grid>
                        <Grid item>
                            <FilterButton label='Location' options={locations}  selected={location_id} onChange={actions.onUpdateLocation}/>
                        </Grid>
                        <Grid item>
                            <DateFilterButton label='Start Date' date={start_date} onChange={actions.onUpdateStartDate}/>
                        </Grid>
                        <Grid item>
                            <DateFilterButton label='End Date' date={end_date} onChange={actions.onUpdateEndDate}/>
                        </Grid>
                        
                    </Grid>
                    <div className={classes.content}>
                        {loading ? <LinearProgress /> : null}
                        <div style={{marginTop:16}}/>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <ActivationsCard catalogs={catalogs} {...activation_data} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TransactionsCard catalogs={catalogs} {...ocl_data} />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <CardholdersCard catalogs={catalogs}  {...cardholders_data} />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                {/*<StackBarTransactions catalogs={catalogs} transactions={transactions} data={transactions_stackbar} />*/}
                                <TransactionListCard transactions={masterTransaction} loading={loading} total={total_data} tableFilter={pagination}
                                onChangeTablePagination={actions.onChangeTablePagination}/>
                            </Grid>
                            {/*<Grid item xs={12} md={4}>
                                <DetailTransactionPieChart catalogs={catalogs} {...balance_data}/>
                            </Grid>*/}
                        </Grid>
                    </div>
                </div>

                : reportPermission.read === false ?
                    <Unauthorized />:
                    <LinearProgress/>
            }
        </>
    )
}

const useStyles = makeStyles(theme => ({
    root:{
        padding:32
    },
    content:{
        marginTop:16
    },
    main:{
        height:'100vh',
        width:'100%',
        overflowY:'auto',
        background:'#edf0f9',
        boxSizing:'border-box',
    }
}))

export default Reports